'use strict';

import $ from 'jquery';

let alternateImagesTimer;
let lastMove = 0;
let lastIndex = 0;
let eventThrottle = 10;

/**
 * Show alternate images
 *
 * @this {HTMLImageElement}
 * @param {JQuery.Event} e
 */
const startAlternateImages = async function (e) {
	e.preventDefault();

	const $target = $(this);
	const target = $target[0];
	const data = $target.data('flipper');
	const imageMode = data.imageMode ?? 'm';

	if (data && data.images.length > 1) {
		if (typeof target.dataset.oldSrc === 'undefined' && !target.classList.contains('lazyload')) {
			target.dataset.oldSrc = target.src;
		}
		if (typeof target.dataset.oldSrcset === 'undefined' && typeof target.srcset !== 'undefined' && !target.classList.contains('lazyload')) {
			target.dataset.oldSrcset = target.srcset;
		}

		if (data.mode === 'single') {
			target.src = mpro.changeImageMode(data.images[1], imageMode);
			if (typeof target.srcset !== 'undefined') {
				target.srcset = mpro.changeImageMode(data.images[1], imageMode);
			}
		}
		else if (data.mode === 'multiple') {
			lastIndex = 1;
			const intervalCallback = async () => {
				target.src = mpro.changeImageMode(data.images[lastIndex], imageMode);
				 if (typeof target.srcset !== 'undefined') {
					target.srcset = mpro.changeImageMode(data.images[lastIndex], imageMode);
				}
				try {
					await target.decode();
				} catch (e) { }

				if (lastIndex < (data.images.length - 1)) {
					lastIndex++;
				} else {
					lastIndex = 0;
				}
			};
			alternateImagesTimer = setInterval(intervalCallback, 1000 * (data.delay || 1));
			intervalCallback();
		}
	}
};

/**
 * Hide alternate images
 *
 * @this {HTMLImageElement}
 * @param {JQuery.TriggeredEvent} e
 */
const stopAlternateImages = async function (e) {
	e.preventDefault();

	const $target = $(this);
	const target = $target[0];
	const data = $target.data('flipper');
	const imageMode = data.imageMode ?? 'm';

	clearInterval(alternateImagesTimer);
	$target.off('mousemove.alternateImages');

	if (data && data.images.length > 0) {
		target.src = (typeof target.dataset.oldSrc !== 'undefined') ? target.dataset.oldSrc : mpro.changeImageMode(data.images[0], imageMode);
		if (typeof target.srcset !== 'undefined') {
			target.srcset = (typeof target.dataset.oldSrcset !== 'undefined') ? target.dataset.oldSrcset : mpro.changeImageMode(data.images[0], imageMode);
		}

		delete target.dataset.oldSrc;
		delete target.dataset.oldSrcset;
	}
};

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	// Handle click event for update wishlist buttons
	$B.on('mouseenter.alternateImages', 'img[data-flipper]', startAlternateImages);
	$B.on('mouseleave.alternateImages', 'img[data-flipper]', stopAlternateImages);
});
